"use client";

import { Analytics, type BeforeSendEvent } from "@vercel/analytics/next";

import {
  ANALYTICS_QA_PARAM,
  isAnalyticsQaUrl,
  redactAnalyticsUrl,
  shouldSuppressAnalytics,
} from "@/lib/analytics-filter";

const QA_SESSION_KEY = "ownly-analytics-qa";

function readQaSession(): boolean {
  try {
    return window.sessionStorage.getItem(QA_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

function rememberQaSession(): void {
  try {
    window.sessionStorage.setItem(QA_SESSION_KEY, "1");
  } catch {
    // The current page is still excluded from its URL in locked-down browsers.
  }
}

/**
 * Playwright is removed automatically. A deliberate human or AI check can add
 * `?ownly_qa=1` once, and the tab remains excluded after internal navigation.
 */
export function OwnlyAnalytics() {
  return (
    <Analytics
      beforeSend={(event: BeforeSendEvent) => {
        if (isAnalyticsQaUrl(event.url)) rememberQaSession();
        if (
          shouldSuppressAnalytics({
            eventUrl: event.url,
            webdriver: navigator.webdriver === true,
            qaSession: readQaSession(),
          })
        ) {
          return null;
        }
        return { ...event, url: redactAnalyticsUrl(event.url) };
      }}
    />
  );
}

export const QA_ANALYTICS_QUERY = `${ANALYTICS_QA_PARAM}=1`;
